<template>
  <div class="flex items-center mx-auto w-fit mt-40px">
    <button @click="$emit('prev')" class="border-2	rounded-sm text-skin-secondary">
      <ChevronLeft/>
    </button>
    <p class="mx-s text-skin-secondary">{{current_page}} / {{last_page}}</p>
    <button @click="$emit('next')"  class="border-2	rounded-sm text-skin-secondary">
      <ChevronRight/>
    </button>
  </div>
</template>

<script>
import ChevronLeft from "./icons/ChevronLeft.vue";
import ChevronRight from "./icons/ChevronRight.vue";
export default {
  components: { ChevronLeft, ChevronRight },
  props:{
    current_page:{
      type: Number
    },
    last_page:{
      type: Number
    },
  }
};
</script>
